module.exports = __webpack_public_path__ + "linijaEasy.ecd8f357c8f55979ee77.jpg";